import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// NOTE, all of this file is shared between the hscontentgeneration plugin and hscopilotcollaboration plugin
export const CONTENT_ASSISTANT_SETTINGS = 'hsContentAssistant';
export const hsContentAssistantConfig = {
  IS_DISABLED: 'isDisabled',
  SLASH_COMMANDS: 'slashCommands',
  SELECTION_COMMANDS: 'selectionCommands',
  BRAND_VOICE_OPTIONS: 'brandVoiceOptions',
  COPILOT_COLLAB_CONTEXT_VALUE: 'copilotCollabContextValue',
  // TODO temporary to prevent breaking builds (TF)
  IS_COPILOT_COLLABORATION_ENABLED: 'isCopilotCollaborationEnabled'
};
export const SUPER_ADMIN_SCOPE = 'super-admin';

/**
 * @deprecated - import types (with enums!) from ui-brand-identity-lib instead
 */

export const TRIGGER = '/';
export const CopilotAutocompleteHeading = () => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  backgroundColor: "fill-field-default",
  padding: "100",
  children: [/*#__PURE__*/_jsx(IconHolder, {
    icon: BreezeSingleStarIcon
  }), /*#__PURE__*/_jsx(Text, {
    as: "h6",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "TinymcePlugins.hscontentgeneration.toolbar.generateLabel"
    })
  })]
});

// @TODO: Remove once IMAGE is injected in hsContentAssistant.slashCommands config everywhere
export const ADD_AI_IMAGE_COMMAND = {
  id: 'generateimage',
  labelKey: 'TinymcePlugins.hsimage.slashCommands.ADD_AI_IMAGE.label'
};